import React from "react";

interface AuthErrorProps {
  error: string;
  onDismiss: () => void;
}

export const AuthError: React.FC<AuthErrorProps> = ({ error, onDismiss }) => {
  return (
    <div
      className="auth-error"
      id="auth-error"
      role="alert"
      aria-live="assertive"
    >
      <svg
        className="error-icon"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <p className="error-text">{error}</p>
      <button
        onClick={onDismiss}
        className="error-dismiss"
        aria-label="Dismiss error"
      >
        ×
      </button>
    </div>
  );
};
